import React from 'react';
import './Features.scss';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import IconList from '../../components/IconList/IconList';
import { useTranslation } from '../../i18n/useTranslation';
import iconOne from '../../assets/features/1.png';
import iconTwo from '../../assets/features/2.png';
import iconThree from '../../assets/features/3.png';
import iconFour from '../../assets/features/4.png';

const Features = () => {
    const { t } = useTranslation();
    
    const featuresData = [
        {
            icon: iconOne,
            title: t('features.safetyFirst.title'),
            description: t('features.safetyFirst.description')
        },
        {
            icon: iconTwo,
            title: t('features.insuranceAccepted.title'),
            description: t('features.insuranceAccepted.description')
        },
        {
            icon: iconThree,
            title: t('features.fullService.title'),
            description: t('features.fullService.description')
        },
        {
            icon: iconFour,
            title: t('features.noJudgment.title'),
            description: t('features.noJudgment.description')
        }
    ];
    
    return (
        <section className='section-bg section-common features-section pt-100 pb-70' data-aos="fade-up" data-aos-duration="2000">
            <div className="container">
                <SectionTitle 
                    subTitle={t('features.subTitle')} 
                    title={t('features.title')} 
                    description={t('features.description')}
                />

                <div className="row align-items-center">
                    {
                        featuresData.map((singleFeature, index) => 
                            <IconList 
                                key={index}
                                icon={singleFeature.icon} 
                                title={singleFeature.title}
                                description={singleFeature.description}
                            />
                        )
                    }
                </div>
            </div>
        </section>
    );
};

export default Features;